import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
    routes: [
        {
            path: '/',
            redirect: '/backstagelogin',
        },
        {
            path:'*',
            name: '404',
            component: () => import('@/views/404')
        },
        {
            path: '/index',
            name: 'index',
            component: () => import('@/views/index'),
            meta: { requiresAuth: false }
        },
        {
            path: '/login',
            name: 'login',
            component: () => import('@/views/login'),
            meta: { requiresAuth: false }
        },
        {
            path: '/ORcode',
            name: 'ORcode',
            component: () => import('@/views/OR')
        },
        {
            path: '/home',
            name: 'home',
            component: () => import('../views/home'),
            children: [
                {
                    path: '/page1',
                    name: 'page1',
                    component: () => import('../views/page1')
                },
                {
                    path: '/page2',
                    name: 'page2',
                    component: () => import('@/views/page2')
                },
                {
                    path: '/page3',
                    name: 'page3',
                    component: () => import('@/views/page3')
                },
                {
                    path: '/page4',
                    name: 'page4',
                    component: () => import('@/views/page4')
                }
            ]
        },
        {
            path: '/backstagelogin',
            name: 'Backstagelogin',
            component: () => import('../views/backstage/login'),
            meta: { requiresAuth: false }
        },
        {
            path: '/manage',
            name: 'Manage',
            component: () => import('@/views/backstage/Manage'),
            redirect: '/backhome',
            meta: { requiresAuth: true },
            children:[{
                path: '/backhome',
                name: 'backhome',
                component: () => import('../views/backstage/manager/home'),
                meta: ['主页'],
                
            },
            {
                path: '/user',
                name: 'user',
                component: () => import('../views/backstage/manager/user'),
                meta: ['系统管理', '用户管理']
            },
            {
                path: '/company',
                name: 'company',
                component: () => import('../views/backstage/manager/company'),
                meta: ['系统管理', '公司管理']
            },
            {
                path: '/greenhouse',
                name: 'greenhouse',
                component: () => import('../views/backstage/manager/greenhouse'),
                meta: ['系统管理', '大棚管理']
            },
            {
                path: '/qixiang',
                name: 'qixiang',
                component: () => import('../views/backstage/manager/Weather.vue'),
                meta: ['系统管理', '气象管理']
            },
            {
                path: '/ponds',
                name: 'Ponds',
                component: () => import('../views/backstage/manager/ponds'),
                meta: ['系统管理', '鱼塘管理']
            },
            {
                path: '/aquacultureProduct',
                name: 'aquacultureProduct',
                component: () => import('../views/backstage/manager/indexData/aquatic_products.vue'),
                meta: ['主页管理', '水产养殖产量']
            },
            {
                path: '/aquacultureCategory',
                name: 'aquacultureCategory',
                component: () => import('../views/backstage/manager/indexData/aquacultureCategory.vue'),
                meta: ['主页管理', '水产养殖类别']
            },{
                path: '/aquatic_products',
                name: 'aquatic_products',
                component: () => import('../views/backstage/manager/indexData/aquacultureProduct.vue'),
                meta: ['主页管理', '历年水产产量']
            },{
                path: '/fish_species',
                name: 'fish_species',
                component: () => import('../views/backstage/manager/indexData/fish_species.vue'),
                meta: ['主页管理', '主要鱼类']
            },{
                path: '/Marine_fish',
                name: 'Marine_fish',
                component: () => import('../views/backstage/manager/indexData/Marine_fish.vue'),
                meta: ['主页管理', '海水鱼类产量']
            },{
                path: '/Freshwater_fish',
                name: 'Freshwater_fish',
                component: () => import('../views/backstage/manager/indexData/Freshwater_fish.vue'),
                meta: ['主页管理', '淡水鱼类产量']
            },{
                path: '/Mode_aquaculture',
                name: 'Mode_aquaculture',
                component: () => import('../views/backstage/manager/indexData/Mode_aquaculture.vue'),
                meta: ['主页管理', '水产养殖方式']
            },{
                path: '/Proportion_fishery',
                name: 'Proportion_fishery',
                component: () => import('../views/backstage/manager/indexData/Proportion_fishery.vue'),
                meta: ['主页管理', '渔业经济占比']
            },{
                path: '/map',
                name: 'map',
                component: () => import('../views/backstage/manager/indexData/map.vue'),
                meta: ['主页管理', '养殖面积']
            },
            {
                path: '/fish',
                name: 'FishData',
                component: () => import('../views/backstage/manager/FishData'),
                meta: ['饲养数据', '鱼体数据']
            },
            // '/camera' route removed to hide monitoring page from navigation and direct access
            {
                path: '/sensorData',
                name: 'sensorData',
                component: () => import('../views/backstage/manager/sensorDataNew'),
                meta: ['环境数据管理', '传感器数据']
            },
            {
                path: '/sensorDataNew',
                name: 'sensorDataNew',
                component: () => import('../views/backstage/manager/sensorDataNew'),
                meta: ['环境数据管理', '传感器数据']
            },
            {
                path: '/ArtWaterQualifyData',
                name: 'ArtWaterQualifyData',
                component: () => import('../views/backstage/manager/ArtWaterQualifyData'),
                meta: ['水质数据', '人工数据']
            },
            {
                path: '/qrcode',
                name: 'QRcode',
                component: () => import('../views/backstage/manager/qrcode'),
                meta: ['水质数据', '人工数据']
            },
            // 预测模型相关路由已移除（溶解氧/水质/投喂预测已不使用）
            {
                path: '/mqttTest',
                name: 'mqttTest',
                component: () => import('../views/backstage/manager/mqttTest'),
                meta: ['设备管理', 'MQTT测试']
            },
            {
                path: '/sensorDevice',
                name: 'sensorDevice',
                component: () => import('../views/backstage/manager/sensorDevice'),
                meta: ['设备管理', '传感器设备']
            },
            {
                path: '/controlDevice',
                name: 'ControlDevice',
                component: () => import('../views/backstage/manager/controlDevice'),
                meta: ['设备管理', '控制设备']
            },
        {
            path: '/ezviz-device',
            name: 'ezvizDevice',
            component: () => import('../views/backstage/manager/ezviz-device'),
            meta: ['设备管理', '录像设备']
        },
        {
            path: '/test',
            name: 'test',
            component: () => import('../views/test'),
            meta: { requiresAuth: false }
        },
        ]
        },
    ],

})


//路由守卫
router.beforeEach((to, from, next) => {
    // 如果访问登录页面，直接放行
    if (to.path === '/backstagelogin' || to.path === '/login' || to.path === '/index') {
        next()
    } else {
        // 检查是否有用户信息（包含token）
        let userStr = localStorage.getItem('user')
        if (userStr) {
            try {
                let user = JSON.parse(userStr)
                if (user && user.token) {
                    next()
                } else {
                    next('/backstagelogin')
                }
            } catch (e) {
                next('/backstagelogin')
            }
        } else {
            next('/backstagelogin')
        }
    }
})

export default router
